'use client';
import { createComponent } from "../internals/utils/index.js";
/**
 * The `Sidenav.Header` component for use with the `Sidenav` component.
 *
 * @see https://rsuitejs.com/components/sidenav
 */
var SidenavHeader = createComponent({
  name: 'SidenavHeader'
});
export default SidenavHeader;